export const clearScanedString = (scanned) => {
    try {
        let text = ''

        if (scanned) {
            text = scanned.replace(/\0/g, '');
        }

        return text
    } catch (e) {

    }
}